module.exports = __webpack_public_path__ + "img/blog-3.jpg?800538f278394996347e21e3588e1d3a";